import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Truck, RotateCcw } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white/80 mt-20">
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div className="flex items-start gap-3" data-testid="footer-transport">
            <Truck className="h-6 w-6 text-brand shrink-0" />
            <div>
              <p className="font-heading font-semibold text-white">Transporte</p>
              <p className="text-sm">Enviamos su pedido personalizado a su empresa.</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-testid="footer-returns">
            <RotateCcw className="h-6 w-6 text-brand shrink-0" />
            <div>
              <p className="font-heading font-semibold text-white">Devoluciones</p>
              <p className="text-sm">Si el producto no es el solicitado, devolución en 15 días.</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-testid="footer-support">
            <Clock className="h-6 w-6 text-brand shrink-0" />
            <div>
              <p className="font-heading font-semibold text-white">Soporte</p>
              <p className="text-sm">Lunes a viernes de 08:00 a 15:00 horas.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="inline-block bg-white rounded-lg p-3">
            <img src={"/logo.svg"} alt="FABRIPAN" className="h-10 w-auto" />
          </div>
          <p className="text-sm mt-3">Directo de fábrica a su panadería. Fabricación bajo pedido de equipamiento profesional.</p>
        </div>
        <div>
          <p className="font-heading font-semibold text-white mb-3">Tienda</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/tienda" className="hover:text-brand transition-colors">Todos los productos</Link></li>
            <li><Link to="/sobre-nosotros" className="hover:text-brand transition-colors">Sobre nosotros</Link></li>
            <li><Link to="/contacto" className="hover:text-brand transition-colors">Contacto</Link></li>
            <li><Link to="/mi-cuenta" className="hover:text-brand transition-colors">Mi cuenta</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-heading font-semibold text-white mb-3">Información</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/pagina/envios" className="hover:text-brand transition-colors">Envíos</Link></li>
            <li><Link to="/pagina/devoluciones" className="hover:text-brand transition-colors">Devoluciones</Link></li>
            <li><Link to="/pagina/pago-seguro" className="hover:text-brand transition-colors">Pago seguro</Link></li>
            <li><Link to="/pagina/terminos-condiciones" className="hover:text-brand transition-colors">Términos y condiciones</Link></li>
            <li><Link to="/pagina/aviso-legal" className="hover:text-brand transition-colors">Aviso legal</Link></li>
            <li><Link to="/pagina/politica-privacidad" className="hover:text-brand transition-colors">Política de privacidad</Link></li>
            <li><Link to="/pagina/politica-cookies" className="hover:text-brand transition-colors">Política de cookies</Link></li>
            <li><button type="button" onClick={() => window.dispatchEvent(new Event("fp:open-cookies"))} className="hover:text-brand transition-colors" data-testid="configure-cookies-link">Configurar cookies</button></li>
          </ul>
        </div>
        <div>
          <p className="font-heading font-semibold text-white mb-3">Contacto</p>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-brand" /> Av. Setze, 5, Urb. la Florida, 08130 Santa Perpetua de la Moguda</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-brand" /> <a href="tel:+34931739860" className="hover:text-brand">+34 931 739 860</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-brand" /> <a href="mailto:info@fabripan.com" className="hover:text-brand">info@fabripan.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
        © {new Date().getFullYear()} FABRIPAN — Directo de fábrica a su panadería. Todos los derechos reservados.
        <span className="mx-2 text-white/20">·</span>
        <Link to="/admin" className="text-white/40 hover:text-brand transition-colors" data-testid="employee-access-link">Acceso empleados</Link>
      </div>
    </footer>
  );
}
